import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfShowOriginIconProps extends SvgIconProps  {}
/**
 * component used to display show origin icon in interaction space header
 * @param props - CcfShowOriginIconProps
 * @example - <CcfShowOriginIcon />
 * @returns SVG of show origin icon in interaction space header
 */
export function CcfShowOriginIcon(props: CcfShowOriginIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_show_origin" clip-path="url(#clip-ic_show_origin)">
        <path id="Icon_material-desktop-windows" data-name="Icon material-desktop-windows" d="M15.5,3H2.9A1.4,1.4,0,0,0,1.5,4.4v8.4a1.4,1.4,0,0,0,1.4,1.4H7.8v1.4H6.4V17H12V15.6H10.6V14.2h4.9a1.4,1.4,0,0,0,1.4-1.4V4.4A1.4,1.4,0,0,0,15.5,3Zm0,9.8H2.9V4.4H15.5Z" transform="translate(0.8)"/>
      </g>
    </SvgIcon>
  );
}

export default CcfShowOriginIcon;
